import {useContext, useEffect, useState, useCallback, useRef} from 'react';
import {Button, MenuItem, CircularProgress, Container, FormControlLabel, Grid, TextField, FormControl, Select} from '@mui/material';
import {useParams, useHistory} from 'react-router-dom';
import {Controller, useForm} from 'react-hook-form';
import {NotificationContext} from "../../../../components/NotificationContext";
import Prompt from "../../../../customUtil/Prompt";
import {BillingCategory, ProjectSendService, ProjectCodeService, ProjectCodeUpdateService} from '../../../../services';
import {CurrentUserContext} from "../../../../components/CurrentUserContext";
import { DataGrid, GridToolbar, GridEditInputCell, GridRowEditStopReasons,
   useGridApiRef, GridRowModes, GridActionsCellItem } from "@mui/x-data-grid";
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import EditIcon from '@mui/icons-material/Edit';
import BlockIcon from '@mui/icons-material/Block';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';

const InvoiceTrackerForm = () => {
    const methods = useForm();
    const {handleSubmit, control} = methods;
    const user = useContext(CurrentUserContext);
    const [data, setData] = useState({});
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [billingCategory, setBillingCategory] = useState([]);
    const {showMessage, showError} = useContext(NotificationContext);
    const [isReady, setIsReady] = useState(false);
    const {id} = useParams();
    const [status, setStatus] = useState('')
    const history = useHistory();
    const [block, setBlock] = useState(false);  
    const refSubmitButtom = useRef();
    const [editedRow, setEditedRow] = useState([]);
    const [enableEdit, setEnableEdit] = useState(false);
    const apiRef = useGridApiRef();
    const [triggerExit, setTriggerExit] = useState({
        onOk: false,
        path: ""
      });
    const [isVisibleDialog, setVisibleDialog] = useState(false);
    let promiseTimeout;
    const source = ['Wambo', 'Wambo (C19RM21)'];
    const [rowModesModel, setRowModesModel] = useState({});
    const [projectErrorMessage, setProjectErrorMessage] = useState(null);
    const [budgetErrorMessage, setBudgetErrorMessage] = useState(null);
   
 


      const StyledBox = styled('div')(({ theme }) => ({
    //    height: 400,
        width: '100%',
        '& .MuiDataGrid-cell--editable': {
          backgroundColor: theme.palette.mode === 'dark' ? '#D6F3FF' : '#EAF9FF',
          '& .MuiInputBase-root': {
            height: '100%',
          },
        },
        '& .Mui-error': {
          backgroundColor: `rgb(126,10,15, ${theme.palette.mode === 'dark' ? 0 : 0.1})`,
          color: theme.palette.mode === 'dark' ? '#ff4343' : '#750f0f',
        },
      }));

    const handleGoToIntendedPage = useCallback(
        (location) => history.push(location),
        [history]
      );

      const columns = [
        {field: 'lineNum', headerName: 'Line Number', width: 100}, 
        {field: 'extConfirmationNumber', headerName: 'ExtConf Num', width: 100, editable:true},           
        {field: 'billingCategory', headerName: 'Billing Category', width: 300, editable: true,
         type: 'singleSelect', 
         valueOptions: () => { const options = [];
             billingCategory?.map((type) =>options.push(type.billingCategory))
             return options
           }
         },             
       
        {field: 'costType', headerName: 'Cost Type', width: 150,
        },
        {field: 'item', headerName: 'Item', width: 125,
        },
        {field: 'lineValue', headerName: 'Line Value', width: 100, align: 'right'
        },  
        {field: 'account', headerName: 'Account', width: 130,
        },
        {field: 'source', headerName: 'Source', width: 110, editable:true,
            type: 'singleSelect', 
            valueOptions: () => { const options = [];
                source?.map((type) =>options.push(type))
                return options
              }
        }, 
        {
          field: 'actions',
          type: 'actions',
          headerName: 'Actions',
          width: 100,
          cellClassName: 'actions',
          getActions: ({ id }) => {
            const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
            if (isInEditMode) {
              return [
                <GridActionsCellItem
                  icon={<SaveIcon />}
                  label="Save"
                  sx={{
                    color: 'primary.main',
                  }}
                  onClick={handleSaveClick(id)}
                />,
                <GridActionsCellItem
                  icon={<CancelIcon />}
                  label="Cancel"
                  className="textPrimary"
                  onClick={handleCancelClick(id)}
                  color="inherit"
                />,
              ];
            }
           
            return [
              <GridActionsCellItem
                icon={<EditIcon />}
                label="Edit"
                className="textPrimary"
                onClick={handleEditClick(id)}
                color="inherit"
               
              />
            ];
                                  
          },
        },
    ]
  
      useEffect(() => {       
        const unblock = history.block((location) => {
          if (location.pathname !== `integrations/onecp/project-codes/${id}`) {
            if(block){
                setVisibleDialog(true);   
                setTriggerExit({...triggerExit, path: location.pathname});
            }else{
                setVisibleDialog(false);   
                setTriggerExit({onOk: true, path: location.pathname});
            }
                           
              }
         
          if (triggerExit.onOk) {
            return true;
          }
          return false;
        });
        if (triggerExit.onOk) {
            handleGoToIntendedPage(triggerExit.path);
          }
        return () => {
          unblock();
        };
      }, [history, triggerExit.onOk, triggerExit.path, block]);

      const handleRowEditStop = (params, event) => {
        const updatedRow = apiRef.current.getRowWithUpdatedValues(params.id);
        setList(list?.map((row) => (row.id === updatedRow.id ? updatedRow : row)));
        if (params.reason === GridRowEditStopReasons.rowFocusOut) {
          event.defaultMuiPrevented = true;
        }
      };

      const handleRowEditStart = (
        params,
        event,
      ) => {
        event.defaultMuiPrevented = true;
      };

      const handleSend = () => {
        setBlock(false);
        setLoading(true);
        ProjectSendService.sendProjectToCp(id).then((response) => {
          if(response.data === "success"){
            showMessage(response.data)
            setLoading(false)
            
          }else{
            showError("Project/Budget not integrated.  You will receive a notification shortly");
            setLoading(false)
         //   window.location.reload(); 
          }
        })
      }

      const handleEditClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
      };
    
      const handleSaveClick = (id) => () => {
        setBlock(true);
       const newRow = apiRef.current.getRowWithUpdatedValues(id);
       setList(list?.map((row) => (row.id === newRow.id ? newRow : row)));
       let tempList = [];
       if(editedRow.length === 0){
        setEditedRow([...editedRow, newRow])
      }else{
        for(let row of editedRow){
          if(row.id !== newRow.id){
             tempList.push(row);
          }
        }
        tempList.push(newRow);
        setEditedRow(tempList);
      } 
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View, ignoreModifications: false } });
      };
    
    
      const handleCancelClick = (id) => () => {
        setRowModesModel({
          ...rowModesModel,
          [id]: { mode: GridRowModes.View, ignoreModifications: true },
        });
    
         };

    
    
      const handleRowModesModelChange = (newRowModesModel) => {
        setRowModesModel(newRowModesModel);
      };

      function renderEditProject(params) {
        return <NameEditInputCell {...params} />;
      }

      const StyledTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
      ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
          backgroundColor: theme.palette.error.main,
          color: theme.palette.error.contrastText,
        },
      }));

      function NameEditInputCell(props) {
        const { error } = props;      
        return (
          <StyledTooltip open={!!error} title={error}>
            <GridEditInputCell {...props} />
          </StyledTooltip>
        );
      }   
      
     
      useEffect(() => {
        return () => {
          clearTimeout(promiseTimeout);
        };
      }, []);

      useEffect(() => {     
        ProjectCodeService.getById(id)
        .then((response) => {
            setList(response.data);               
            if(response.data[0].projectCodeMessage !== null){
              const dotIndex = response.data[0].projectCodeMessage.indexOf(".");
              setProjectErrorMessage(dotIndex !== -1 ? response.data[0].projectCodeMessage.substring(0, dotIndex) : response.data[0].projectCodeMessage);         
            }
            if(response.data[0].budgetMessage !== null){
              const dotIndex = response.data[0].budgetMessage.indexOf(".");
              setBudgetErrorMessage(dotIndex !== -1 ? response.data[0].budgetMessage.substring(0, dotIndex) : response.data[0].budgetMessage);         
            }
            setIsReady(true);    
           setLoading(false);      
        });           
        BillingCategory.getAll().then((response) => {
            setBillingCategory(response.data);
            })         
        }, []);


           

      const onSubmit = d => {
       setIsReady(false);
        setBlock(false);
        setVisibleDialog(false);            
        if(editedRow.length > 0){
          setIsReady(true);   
          setLoading(true) 
          for(let row of editedRow){
            row['lastUpdatedBy'] =  user.currentUser.username;
          }
          ProjectCodeUpdateService.updateProjectCode(editedRow[0].projectId, editedRow).then((response) => {   
            showMessage('Project/Budget lines Updated');       
            setIsReady(true);
            setLoading(false); 
                 })
        }  
             
    };


    if (!isReady) {
        return (
            <CircularProgress/>
        );
    }
    const triggerSubmit = () => {
        refSubmitButtom?.current?.click();
      };     

    
     
          const handleChange = (e) => {
        setStatus(e.target.value);
      }
   
      const onSave = (event) => {
          triggerSubmit();
          setBlock(false);
          setVisibleDialog(false);
      }
  
      const checkModified = (event) => {
          if(event.type ===  "change"){
              setBlock(true);
                 }
              }
            

              return (
                <Container>                
        
                    <form style={{textAlign: 'left'}} onSubmit={handleSubmit(onSubmit)} onChange={event => {checkModified(event)}}>
                    <Prompt
                       visible={isVisibleDialog}
                       onClose={() => setVisibleDialog(false)}
                       onOk={() => {
                       setTriggerExit({...triggerExit, onOk: true});
                       setVisibleDialog(false);
                       setBlock(false);
                    }}
                       onSave={onSave}
                    />
                     
                        <button hidden={true} ref={refSubmitButtom} type={"submit"} />
             
                    <Grid xs={12} m={2}>    
                    <header>
                        <h1>Project/Budget {list[0].projectId}</h1>
                    </header>
                    <Grid xs={12} m={2}>
                    {projectErrorMessage != null && 
                     <div>
                     ProjectCode Error Message 
                     <span style={{color: "red"}}> *{projectErrorMessage}*</span>
                   </div>
                    }
                     {budgetErrorMessage != null && 
                     <div>
                     Budget Error Message 
                     <span style={{color: "red"}}> *{budgetErrorMessage}*</span>
                     
                   </div>
                    }
                   </Grid>
                    <StyledBox>   
                       <DataGrid   
                           apiRef={apiRef}
                           autoHeight
                           rows={list}
                           columns={columns}
                           slots={{toolbar: GridToolbar}}
                           loading={loading}
                           editMode="row"
                           rowModesModel={rowModesModel}
                           onRowModesModelChange={handleRowModesModelChange}
                           onRowEditStart={handleRowEditStart}
                           onRowEditStop={handleRowEditStop}
                           //onRowClick={handleEvent}
                          //  processRowUpdate={processRowUpdate}                           
                           disableColumnSelector                                    
                           disableVirtualization={false}      
                           rowHeight={35}      
                           initialState={{
                            pagination: {
                              paginationModel: { pageSize: 50, page: 0 },
                            },
                          }}
                           pagination
                           slotProps={{
                            toolbar: 
                            { 
                              showQuickFilter: true ,
                             quickFilterProps: { debounceMs: 600 },
                                     }
                          }}
                       />
                       </StyledBox>  
                    </Grid>
                    <Grid container spacing={6}>
                     <Grid item xs={11} >
                     <Button variant="contained" color="primary" type="submit">Update</Button>
                       </Grid>  
                       <Grid item xs={1} >
                     <Button variant="contained"  onClick={handleSend}>Send</Button>
                       </Grid> 
                     </Grid>  
                    </form>
                </Container>
              );

}

export default InvoiceTrackerForm;